import { PagedResultWithPager } from '@extrahorizon/javascript-sdk';
import { TableInput } from 'models/general';
import { WorklistData, WorklistStatus } from 'models/worklist';
import { EmptyParametersError } from 'services/errors/EmptyParametersError';
import { formatToIso } from 'utils/dates';
import { getActiveGroupIds } from 'utils/filters';
import { API_FUNCTIONS, queryParams, RULES_ENDPOINTS, sdk } from 'utils/query';

export const getWorkListRecords = async ({ pageParam, filters, currentUser, config, limit = 20 }: TableInput) => {
  if (!currentUser) throw new EmptyParametersError();

  const sort = filters.sort || config.defaultSort;

  let rql = `limit=${limit}&offset=${pageParam * limit}&sort=${sort}`;
  const relevantGroupIds = getActiveGroupIds(currentUser.visibleGroupsIds, filters[queryParams.groups]);
  const recipientGroupIds = relevantGroupIds.map((id) => `recipientGroupIds=${id}`).join('&');
  rql += `&${recipientGroupIds}`;

  if (filters[queryParams.title]) {
    rql += `&${queryParams.title}=${filters[queryParams.title]}`;
  }

  const filterStatus = filters[queryParams.status] || config?.defaultFilters?.[queryParams.status];
  if (filterStatus && filterStatus !== WorklistStatus.All) {
    rql += `&${queryParams.status}=${filterStatus}`;
  }

  if (filters[queryParams.priority]) {
    const priorityList = filters[queryParams.priority].split(',');
    const priorities = priorityList.map((priority) => `priorities=${priority}`).join('&');
    rql += `&${priorities}`;
  }

  if (filters[queryParams.startDate]) {
    const startDate = formatToIso(filters[queryParams.startDate]);
    rql += `&from=${startDate}`;
  }

  if (filters[queryParams.endDate]) {
    const endDate = formatToIso(filters[queryParams.endDate]);
    rql += `&until=${endDate}`;
  }

  const result = await sdk.tasks.api.get<PagedResultWithPager<WorklistData>>(
    API_FUNCTIONS.monitoring,
    `${RULES_ENDPOINTS.monitoringNotifications}?${rql}`,
    {},
  );

  return result;
};
